"use client";
import Image from "next/image";
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { IoMdClose } from "react-icons/io";
import { ImArrowRight, ImArrowLeft } from "react-icons/im";

export default function ImageViewer(props) {
  const gallery = props.data?.[0]?.images?.data || [];
  const selectedImage = props.selectedImage;

  const selectedIndex = gallery.findIndex(
    (image) => image.id === selectedImage.id
  );
  const [currentIndex, setCurrentIndex] = useState(selectedIndex);
  const [mainImage, setMainImage] = useState(selectedImage.attributes.url);
  const nextImage = () => {
    let totalImageCount = gallery.length;
    if (currentIndex < totalImageCount - 1) {
      setCurrentIndex(currentIndex + 1);
      setMainImage(gallery[currentIndex + 1].attributes.url);
    } else {
      setCurrentIndex(0);
      setMainImage(gallery[0].attributes.url);
    }
  };
  const prevImage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setMainImage(gallery[currentIndex - 1].attributes.url);
    } else {
      setCurrentIndex(gallery.length - 1);
      setMainImage(gallery[gallery.length - 1].attributes.url);
    }
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => nextImage(),
    onSwipedRight: () => prevImage(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // Optional, enable mouse events
  });

  return (
    <div className="image-viewer">
      <div className="image-viewer-head">
        <div className="button-wrapper">
          <button onClick={prevImage}>
            <ImArrowLeft />
          </button>

          <button onClick={nextImage}>
            <ImArrowRight />
          </button>
        </div>
        <button onClick={() => props.close()}>
          <IoMdClose />
        </button>
      </div>
      <div className="image-viewer-main" {...handlers}>
        <Image
          src={mainImage}
          width={1920}
          height={1080}
          alt={selectedImage.attributes.alternativeText || "Factory Cat"}
        />
      </div>
    </div>
  );
}
